import PRODUCT_REGISTRY_ENUMS from '../enums/productRegistryEnums';

/* eslint-disable complexity */
export function registrySubReducer(state = {}, action = {}) {
    switch (action.type) {
        case PRODUCT_REGISTRY_ENUMS.HIDE_PRODUCT_REGISTRIES:
        case PRODUCT_REGISTRY_ENUMS.HIDE_REGISTRIES_FROM_WISHLIST:
            return Object.assign({}, state, {
                productRegistry: Object.assign({
                    showProductRegistries: false
                })
            });

        case PRODUCT_REGISTRY_ENUMS.ADD_TO_REGISTRY:
            return Object.assign(
                {}, state, {
                    productRegistry: Object.assign(
                        {}, state.productRegistry, {
                            isPending: true,
                            isSuccess: false
                        }
                    ),
                    productListMessages: Object.assign(
                        {}, state.productListMessages, {
                            error: null
                        }
                    )
                }
            );

        case PRODUCT_REGISTRY_ENUMS.ADDED_TO_REGISTRY:
            return Object.assign(
                {}, state, {
                    productRegistry: Object.assign(
                        {}, state.productRegistry, {
                            isPending: false,
                            isSuccess: true,
                            showProductRegistries: false
                        }
                    )
                }
            );

        case PRODUCT_REGISTRY_ENUMS.RESET_ADD_TO_REGISTRY:
            return Object.assign(
                {}, state, {
                    productRegistry: Object.assign(
                        {}, state.productRegistry, {
                            isPending: false,
                            isSuccess: false
                        }
                    )
                }
            );

        case PRODUCT_REGISTRY_ENUMS.SET_PRODUCT_REGISTRY_VERSION:
            return Object.assign(
                {}, state, {
                    productRegistry: Object.assign(
                        {}, state.productRegistry, {
                            registry: Object.assign(
                                {}, state.productRegistry.registry, {
                                    version: action.payload
                                }
                            )
                        }
                    )
                }
            );

        case PRODUCT_REGISTRY_ENUMS.SHOW_PRODUCT_REGISTRIES:
            return Object.assign({}, state, {
                productRegistry: Object.assign({
                    showProductRegistries: true
                })
            });

        default:
            return state;
    }
}
/* eslint-enable complexity */
